// The backend reads the `jwt` cookie as a bearer token under this prefix only, so hub URLs must use it.
export const HUBS_PATH_PREFIX = '/hubs';

export const HUB_RECONNECT_DELAYS_MS: readonly number[] = [
  0, 2000, 5000, 10000,
];
